export const PIPED_READ_OUTPUT_NOTE =
  "Piped output is plain, tab-separated, complete, and machine-readable (no truncation, no color codes) - safe to parse directly without --json.";

export function readCommandDescription(description: string): string {
  return `${description}. ${PIPED_READ_OUTPUT_NOTE}`;
}
